import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { portfolioData } from "../data/mock";

const Hero = () => {
  const { hero } = portfolioData;

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="min-h-screen flex items-center justify-center relative overflow-hidden pt-20"
    >
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-gradient-to-r from-cyan-500/20 to-violet-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gradient-to-r from-violet-500/20 to-pink-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 text-center relative z-10">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img
            src="https://customer-assets.emergentagent.com/job_digital-studio-pro/artifacts/5kz5nw0k_logo_key4.png"
            alt="Web Key Studio"
            className="h-24 w-auto mx-auto mb-4"
          />
        </div>

        {/* Main Title */}
        <h1 className="text-5xl md:text-7xl font-bold mb-6 animate-fade-in-up">
          <span className="bg-gradient-to-r from-cyan-400 via-violet-400 to-pink-400 bg-clip-text text-transparent">
            {hero.title}
          </span>
        </h1>

        {/* Subtitle */}
        <div className="flex items-center justify-center mb-8 animate-fade-in-up delay-200">
          <Sparkles className="text-cyan-400 mr-2" size={20} />
          <h2 className="text-xl md:text-2xl text-slate-300 font-medium">
            {hero.subtitle}
          </h2>
          <Sparkles className="text-violet-400 ml-2" size={20} />
        </div>

        {/* Description */}
        <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto mb-12 leading-relaxed animate-fade-in-up delay-300">
          {hero.description}
        </p>

        {/* CTA Button */}
        <div className="animate-fade-in-up delay-500">
          <button
            onClick={scrollToContact}
            className="group bg-gradient-to-r from-cyan-500 to-violet-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:shadow-cyan-500/25 transition-all duration-300 hover:scale-105 flex items-center mx-auto"
          >
            {hero.cta}
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={20} />
          </button>
        </div>

        {/* Signature */}
        <div className="mt-12 animate-fade-in-up delay-700">
          <p className="text-slate-500 text-sm italic">
            {hero.signature}
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-slate-600 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-gradient-to-b from-cyan-400 to-violet-400 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;